// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__9c__i","hide":"styles_hide__Knwlm"};